import React from 'react';
import { IMyBusinessProps } from '../../My_Business/myBusiness-hooks';
import Main from './Screens/Admin/Main/main';

const RestaurantPage: React.FC<IMyBusinessProps> = (props) => {

  return (
    <>
      <Main {...props}/>
    </>
  )
};

export default RestaurantPage
